import React, { createContext, useState, useContext } from "react";
import Notifications from "../components/Notifications";

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (title, message, type) => {
    const id = Date.now();
    setNotifications((prev) => [...prev, { id, title, message, type }]);

    // Auto-remove notification after 5 seconds
    setTimeout(() => removeNotification(id), 5000);
  };

  const removeNotification = (id) => {
    setNotifications((prev) => prev.filter((notif) => notif.id !== id));
  };

  return (
    <NotificationContext.Provider value={{ addNotification }}>
      {/* Render Notifications component globally */}
      <Notifications notifications={notifications} removeNotification={removeNotification} />
      {children}
    </NotificationContext.Provider>
  );
}

// Custom hook for easy access
export function useNotification() {
  return useContext(NotificationContext);
}
